
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {numeric, required, requiredIf} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import {CounterpartiesUpdateFormRequestType} from "@/form/finance/counterparties/CounterpartiesUpdateForm.types";
import {ICounterpartiesListItem} from "@/entity/finance/counterparties/counterparties.types";
import {ICounterpartiesType, CounterpartiesTypeResponseType} from "@/entity/finance/counterparties/counterpartiesType.types";
import { fio, email, phone } from "@/utils/validators";

@Component
export default class CounterpartiesUpdateForm extends Form{
    id = 0;
    @Validate(required, i18nText("Выберите тип"))
    type_id = 1;
    @Validate(required, i18nText("Введите название"))
    name = '';
    @Validate(required, i18nText("Введите ИНН"))
    inn: string | null = null;
    kpp: string | null = null;
    contact_person: string | null = '';
    @Validate(phone, i18nText("Введите корректный номер телефона"))
    phone: string | null = null;
    @Validate(email, i18nText("Введите корректный Email"))
    email: string | null = null;
    address: string | null = null;
    comment: string | null = null;
    salon_id = 0;
    types = [
        {id: 1, name: i18nText("ИП")},
        {id: 2, name: i18nText("Юридическое лицо")},
        {id: 3, name: i18nText("Физическое лицо")},
    ]
    getFormData(): CounterpartiesUpdateFormRequestType {
        return {
            id: this.id,
            type_id: this.type_id,
            name: this.name,
            inn: this.inn,
            kpp: this.kpp,
            contact_person: this.contact_person,
            phone: this.phone,
            email: this.email,
            address: this.address,
            comment: this.comment,
            salon_id: this.salon_id
        }
    }
    setFormData(item: ICounterpartiesListItem | null, types: ICounterpartiesType[]): void {
        this.types = [];
        for (let i = 0; i < types.length; i++) {
            if(!this.type_id){
                this.type_id = types[i].id;
            }
            this.types.push({...types[i], name: i18nText(types[i].name)});
        }
        if (item !== undefined && item != null) {
            this.id = item.id;
            this.name = item.name;
            this.type_id = item.type.id;
            this.salon_id = item.salon_id;
            //this.status_data = item.status;
            this.inn = item.inn;
            this.kpp = item.kpp;
            this.contact_person = item.contact_person;
            this.phone = item.phone;
            this.email = item.email;
            this.address = item.address;
            this.comment = item.comment;
        }
    }
}
